import { ReactNode } from "react";
import { HeroLayout, HeroLayoutMode } from "@kaltura/mediaspace-shared-layout";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";

interface CommonHeroLayoutProps {
    collapsedHero?: boolean;
    children: ReactNode;
    allowBorderRadius?: boolean;
}

/**
 * Layout for any hero component except meeting room player
 */
export const CommonHeroLayout = ({ collapsedHero, children, allowBorderRadius = true }: CommonHeroLayoutProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

    return (
        <HeroLayout
            allowBorderRadius={allowBorderRadius}
            mode={isMobile || collapsedHero ? HeroLayoutMode.AspectRatio : HeroLayoutMode.FullSize}
            marginBottom={"160px"}
        >
            {children}
        </HeroLayout>
    );
};
